import { useRef } from "react";
import { Tooltip } from "primereact/tooltip";

import { useOverflowWidth } from "@/packages/orion/hooks";
import type { MaterialItem } from "@/service/namek/useGetMaterialsByCVId";

type MaterialsCellProps = {
  materials: MaterialItem[];
  tooltipId: string;
};

const maxWidth = 350;

export const MaterialsCell = ({ materials, tooltipId }: MaterialsCellProps) => {
  const names = materials.map((m) => m.name);
  const targetClass = `materials-tool-${tooltipId}`;
  const textRef = useRef<HTMLDivElement | null>(null);

  const isOverflowing = useOverflowWidth(textRef, [materials]);

  if (names.length === 0) {
    return <div className="max-w-fit">-</div>;
  }

  const displayText = names.join(", ");

  return (
    <div className="min-w-0" style={{ width: maxWidth }}>
      {isOverflowing && (
        <Tooltip
          appendTo={() => document.body}
          className="min-w-40"
          position="top"
          target={`.${targetClass}`}
        >
          <div className="flex flex-col justify-center p-2">
            <span className="text-sm font-bold">Materiales: {materials.length}</span>
            <ul className="mt-1 list-disc pl-4 text-sm">
              {names.map((n) => (
                <li key={n} className="leading-tight">
                  {n}
                </li>
              ))}
            </ul>
          </div>
        </Tooltip>
      )}
      <div ref={textRef} className={`truncate ${targetClass}`}>
        {displayText}
      </div>
    </div>
  );
};
